import React, { useEffect, useState } from 'react';
import api from '../utils/api';

export default function About() {
  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/about').then(({ data }) => setAbout(data.about)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ paddingTop: 70 }}><div className="loading-spinner"><div className="spinner" /></div></div>;

  return (
    <div style={{ paddingTop: 70 }}>
      <div className="page-header">
        <h1>{about?.title || 'About Apex Gaming'}</h1>
      </div>
      <div className="container" style={{ paddingBottom: 80, maxWidth: 800 }}>
        <div className="card" style={{ padding: '48px 40px', lineHeight: 1.8 }}>
          {about?.content ? (
            about.content.split('\n\n').map((para, i) => (
              <p key={i} style={{ color: 'var(--text-secondary)', fontSize: 17, marginBottom: 24 }}>{para}</p>
            ))
          ) : (
            <p style={{ color: 'var(--text-secondary)', textAlign: 'center' }}>Content coming soon...</p>
          )}
        </div>

        <div style={{ marginTop: 48, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px,1fr))', gap: 20 }}>
          {[
            { icon: '🎮', title: 'Gaming First', desc: 'Built by gamers, for gamers.' },
            { icon: '🤝', title: 'Trusted', desc: 'Thousands of happy members.' },
            { icon: '🔒', title: 'Secure', desc: 'Your data is always protected.' },
          ].map(item => (
            <div key={item.title} className="card" style={{ textAlign: 'center', padding: 28 }}>
              <div style={{ fontSize: 36, marginBottom: 12 }}>{item.icon}</div>
              <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 16, color: 'var(--accent-cyan)', marginBottom: 8 }}>{item.title}</h3>
              <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
